import "../../styles/header.css";
import "../../styles/typo.css";

import React, { useState, useContext, useEffect } from "react";
import { Button, Navbar } from "react-bootstrap";
import logo from "../../assets/images/logo/verified_logo_white.svg";
import { useGlobal } from "../../context/globalContext";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { Row } from "react-bootstrap";
import VerticallyModal from "../modal/VerticallyModal";
import HelperModal from "./helperModal";
import UnSupportedModal from "./unSupportedNetwork";
import { networks, ToastOptions, FailureToast } from "../../utils/constants";
import { fetchSumsubAccessToken } from "../../context/globalContext";
import { toast } from "react-toastify";
import {
  useAccount,
  useDisconnect,
  useConnect,
  useClient,
  useConnectorClient,
} from "wagmi";
import {
  getProvider,
  getProviderNetwork,
  getWeb3,
} from "../../utils/helpers/networks";
import KYCModal from "./kycModal";
import { useAppKit } from "@reown/appkit/react";
import Login from "../overlays/login";
import Loader from "../loader";

const { Client, contractAddress } = require("@verified-network/verified-sdk");
const { ethers, providers } = require("ethers");

export const shortAddress = (address = "") => {
  const lst2 = address.slice(-4);
  const first4 = address.slice(0, 5);
  return `${first4}...${lst2}`;
};

const CommonHeader = (props) => {
  const { disconnect } = useDisconnect();
  const { address, isConnected, chainId, isConnecting } = useAccount();
  const { data: client } = useConnectorClient({ chainId });
  const { chain, transport } = client || { chain: null, transport: null };
  let network, provider;
  if (chain) {
    network = getProviderNetwork(chain);
  }
  if (network) {
    provider = getProvider(transport, network);
  }
  let signer, web3;
  if (provider && provider.getSigner && chainId && address) {
    signer = provider.getSigner(address);
    web3 = getWeb3(transport);
  }

  const {
    login,
    userRole,
    kycStatus,
    userAddress,
    connectedChainId,
    setConnectedChainId,
    removeDetails,
    globalLoading,
  } = useGlobal();
  const [showHelperModal, setShowHelperModal] = useState(false);
  const [alertModal, setAlertModal] = useState(false);
  const [accessToken, setAccessToken] = useState(null);
  const [showKYCModal, setshowKYCModal] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  const appKitModal = useAppKit();

  const activeNetworkList = Object.fromEntries(
    Object.entries(networks).filter(
      ([key, value]) => contractAddress[key].Client,
    ),
  );

  useEffect(() => {
    async function switchNetwork() {
      if (
        Object.keys(props.verifiedWalletDetails)?.length === 0 &&
        !Object.keys(activeNetworkList).includes(
          Number(connectedChainId).toString(),
        )
      ) {
        setAlertModal(true);
      } else {
        setAlertModal(false);
      }
    }
    if (connectedChainId) {
      switchNetwork();
    }
  }, [connectedChainId]);

  const handleNetworkSwitch = async (networkName) => {
    console.log("networkName", networkName);
    await changeNetwork({ networkName });
  };

  const changeNetwork = async ({ networkName }) => {
    try {
      if (props.verifiedWalletDetails?.address?.length > 0) {
        setConnectedChainId(Number(networkName));
        await passBaseRequest(
          props.verifiedWalletDetails?.address,
          Number(networkName),
          { ...props.verifiedWalletDetails, chainId: Number(networkName) },
        );
      } else {
        if (window.ethereum) {
          await window.ethereum.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                ...networks[networkName],
              },
            ],
          });
        }
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  React.useEffect(() => {
    if (
      (address?.length > 0 && chainId && !props.verifiedWalletDetails) ||
      (Object.keys(props.verifiedWalletDetails)?.length === 0 &&
        address?.length > 0 &&
        chainId)
    ) {
      passBaseRequest(address, chainId, {});
    }
  }, [address, chainId, transport]);

  React.useEffect(() => {
    if (
      props.verifiedWalletDetails?.address &&
      props.verifiedWalletDetails?.chainId
    ) {
      passBaseRequest(
        props.verifiedWalletDetails?.address,
        props.verifiedWalletDetails?.chainId,
        props.verifiedWalletDetails,
      );
    }
  }, [props.verifiedWalletDetails]);

  React.useEffect(() => {
    if (
      (address?.length > 0 && chainId && !props.verifiedWalletDetails) ||
      (Object.keys(props.verifiedWalletDetails)?.length === 0 &&
        address?.length > 0 &&
        chainId)
    ) {
      if (window.ethereum?.on) {
        window.ethereum.on("accountsChanged", () => {
          passBaseRequest(address, chainId, {});
        });
        window.ethereum.on("chainChanged", () => {
          passBaseRequest(address, chainId, {});
        });
        window.ethereum.on("changed", () => {
          passBaseRequest(address, chainId, {});
        });
        //Todo: handle more events
      }
    }
  }, [address, chainId]);

  const passBaseRequest = async (_address, _chainId, verifiedWalletDetails) => {
    if (_address && _chainId) {
      // console.log("will fetch AccessToken and loginnnnn...");
      const data = await fetchSumsubAccessToken(_address, Number(_chainId));
      setAccessToken(data?.accessToken);
      await login(verifiedWalletDetails);
    }
  };

  return (
    <>
      {globalLoading ? <Loader /> : <></>}
      <header className="bg" style={{ height: "75px" }}>
        <Navbar expand="lg">
          <a href={`/`}>
            <Navbar.Brand>
              <img src={logo} alt="Logo" />{" "}
            </Navbar.Brand>
          </a>
          <div className="d-flex justify-content-end connect-btn align-items-center text-white">
            <div className="mr-2">
              {connectedChainId ? (
                <DropdownButton
                  id="dropdown-basic-button"
                  title={
                    connectedChainId
                      ? networks[Number(connectedChainId)]?.chainName
                      : "Select Network"
                  }
                >
                  {Object.keys(activeNetworkList).map((network) => {
                    return (
                      <Dropdown.Item
                        key={network}
                        className={
                          Number(connectedChainId) === network
                            ? "selectedNetwork"
                            : null
                        }
                        onClick={() => {
                          handleNetworkSwitch(network);
                        }}
                      >
                        {networks[network].chainName}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              ) : null}
            </div>
            {userAddress ? (
              <div className="rounded p-2">
                <b>Account:</b> {shortAddress(userAddress)}
              </div>
            ) : null}
            {userAddress &&
              userRole?.toLowerCase() !== "admin" &&
              kycStatus !== 3 && (
                <Button
                  className="btn-index"
                  onClick={async () => {
                    if (userAddress && connectedChainId) {
                      props.setGeneralLoading(true);
                      const data = await fetchSumsubAccessToken(
                        userAddress,
                        connectedChainId,
                      );
                      setAccessToken(data.accessToken);
                      setshowKYCModal(true);
                      props.setGeneralLoading(false);
                    }
                  }}
                  style={{ marginRight: "10px" }}
                  variant="outline-light"
                >
                  Verify KYC
                </Button>
              )}
            <Button
              className="btn-index"
              onClick={async () => {
                if (!userAddress) {
                  setShowLogin(true);
                } else {
                  if (
                    Object.values(props.verifiedWalletDetails || {})?.length ===
                    0
                  ) {
                    disconnect();
                    removeDetails();
                  } else {
                    // localStorage.removeItem("myVault");
                    removeDetails();
                    window.location.href = window.location.origin;
                  }
                }
              }}
              variant="outline-light"
            >
              {userAddress?.length > 0 ? "Disconnect Wallet" : "Connect Wallet"}
            </Button>
          </div>
        </Navbar>
        {showHelperModal && <HelperModal />}
        {alertModal && (
          <UnSupportedModal
            alertModal={alertModal}
            switchNetwork={handleNetworkSwitch}
            activeNetworkList={activeNetworkList}
            chainName={networks[Number(chainId)]?.chainName}
          />
        )}
        {showKYCModal && (
          <KYCModal
            accessToken={accessToken}
            setshowKYCModal={setshowKYCModal}
            showKYCModal={showKYCModal}
          />
        )}
        {showLogin && (
          <VerticallyModal
            key="connectProvider"
            showModal={showLogin}
            modalSize={"xs"}
            modalOnHide={() => {
              setShowLogin(false);
            }}
            modalHeading="Login Options"
            withFooter={false}
          >
            <Login
              setVerifiedWalletDetails={props.setVerifiedWalletDetails}
              setShowPopup={setShowLogin}
              setCustomLoading={props.setGeneralLoading}
            />
          </VerticallyModal>
        )}
      </header>
    </>
  );
};

export default CommonHeader;
